export const BASE = {
  name: 'heatmap',
  path: '/sites/:siteId/heatmap',
} as const;

export const LIST = {
  name: 'heatmap.list',
  path: `${BASE.path}/list/`,
} as const;

export const LIST_CONTINUOUS_CAPTURE = {
  name: 'heatmap.list.continuous-capture',
  path: `${BASE.path}/view`,
} as const;

export const LIST_SNAPSHOTS = {
  name: 'heatmap.list.snapshots',
  path: `${LIST.path}?snapshots`,
} as const;

export const CREATE = {
  name: 'heatmap.create',
  path: `${BASE.path}/create/:copyId`,
} as const;

export const EDIT = {
  name: 'heatmap.edit',
  path: `${BASE.path}/edit/:heatmapId`,
} as const;

export const REPORT = {
  name: 'heatmap.report',
  path: `${BASE.path}/report/:heatmapId`,
} as const;
